export default __webpack_public_path__ + "graphql.e8ab9e47.png";